import { axiosInstance } from '../utils/apiRequest';
import NProgress from 'nprogress/nprogress';

export default {
  mounted() {
    const self = this;
    // Add a request interceptor
    axiosInstance.interceptors.request.use((config) => {
      if (!self.runningApiCount) {
        NProgress.start();
      }
      self.runningApiCount++;

      return config;
    }, (error) => {
      return Promise.reject(error);
    });

    // Add a response interceptor
    axiosInstance.interceptors.response.use((response) => {
      self.runningApiCount--;

      setTimeout(() => {
        if (!self.runningApiCount) {
          self.$nextTick(() => {
            NProgress.done();
          });
        }
      }, 300);

      return response;
    }, (error) => {
      self.runningApiCount--;
      if (!self.runningApiCount) {
        self.$nextTick(() => {
          NProgress.done();
        });
      }
      return Promise.reject(error);
    });
  },
  data() {
    return {
      runningApiCount: 0,
    };
  },
};
